import { useState } from "react"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Uploader } from "../../components/Uploader"
import { Button } from "../../components/Button"
import { ContentWrapper } from "../../components/Wrappers"
import {
  WEB_PORTALS,
  STORAGE_ENCRYPTED_DATA,
  STORAGE_IV,
} from "../../constants"
import { getStorageVariable } from "../../utils/storage"
import { ProgressBar } from "../../components/ProgressBar"
import { deployImages } from "../../services/deploy-images"

const { slovakCryptoNews, slovakFtNews } = WEB_PORTALS

export const UploadImages: React.FC = () => {
  const { t } = useTranslation()
  const [message, setMessage] = useState<{
    data: { imageName: string; progress: number }
    message: string
  }>({
    data: { imageName: "", progress: 0 },
    message: "",
  })
  const [isLoading, setIsLoading] = useState(false)

  const knData = getStorageVariable(
    `${slovakCryptoNews}${STORAGE_ENCRYPTED_DATA}`,
  )
  const knIv = getStorageVariable(`${slovakCryptoNews}${STORAGE_IV}`)
  const ftnData = getStorageVariable(`${slovakFtNews}${STORAGE_ENCRYPTED_DATA}`)
  const ftnIv = getStorageVariable(`${slovakFtNews}${STORAGE_IV}`)

  const startImportHandler = async () => {
    setIsLoading(true)
    await deployImages({ knData, knIv, ftnData, ftnIv }, (partialMessage) => {
      setMessage(JSON.parse(partialMessage))
    })
    setIsLoading(false)
  }

  return (
    <ContentWrapper>
      <Flex vertical gap="large">
        <>
          <Uploader
            name={t("uploading.knImageUpload")}
            fileType="webp"
            web="kn"
          />
          <Uploader
            name={t("uploading.ftnImageUpload")}
            fileType="webp"
            web="ftn"
          />
        </>
        <Flex justify="center" vertical gap="large">
          {message.data.progress > 0 && (
            <ProgressBar
              progress={message.data.progress}
              message={message.message}
              process="uploadingImage"
              articleName={message.data.imageName}
            />
          )}
          <Button
            label={isLoading ? t("uploading.importing") : t("uploading.import")}
            type="primary"
            onClick={startImportHandler}
            style={{ width: "300px", margin: "0 auto" }}
            loading={isLoading}
          />
        </Flex>
      </Flex>
    </ContentWrapper>
  )
}
